var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceSelectYourNumber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.76449 7.39941L8.03958 7.32628C7.14429 7.28833 6.43859 6.55044 6.44056 5.65434C6.4426 4.73361 7.18957 3.98828 8.11031 3.98828H24.0739C24.3789 3.98828 24.6261 4.23549 24.6261 4.54043V7.25834",
    stroke: "#76BC21",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3881 17.5648C18.9201 17.5648 20.162 16.3099 20.162 14.7619C20.162 13.2139 18.9201 11.959 17.3881 11.959C15.8562 11.959 14.6143 13.2139 14.6143 14.7619C14.6143 16.3099 15.8562 17.5648 17.3881 17.5648Z",
    stroke: "#76BC21",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7247 20.416H19.6293C21.4242 20.416 22.8793 21.8711 22.8793 23.666V25.4397C22.8793 25.5778 22.7673 25.6897 22.6293 25.6897H12.7247C12.5867 25.6897 12.4747 25.5778 12.4747 25.4397V23.666C12.4747 21.8711 13.9298 20.416 15.7247 20.416Z",
    stroke: "#76BC21",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75366 7.39453H27.0037C27.694 7.39453 28.2537 7.95418 28.2537 8.64453V29.9875C28.2537 30.6778 27.694 31.2375 27.0037 31.2375H10.0037C8.20874 31.2375 6.75366 29.7824 6.75366 27.9875V7.39453Z",
    stroke: "#76BC21",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceSelectYourNumber);
export default __webpack_public_path__ + "static/media/serviceSelectYourNumber.e4af787e90575713b78f8cd7c0f00f0a.svg";
export { ForwardRef as ReactComponent };